export const courseReducer = (state, action) => {
  switch (action.type) {
    case "loadCourse":
      console.log("loading course");
      return loadCourse(state, action.courses);
    case "addCourse":
      console.log("adding course");
      return addCourse(state, action.course);
    case "editCourse":
      console.log("editing course");
      return editCourse(state, action.course);
    case "disableCourse":
      console.log("disabling course");
      return disableCourse(state, action.courseCode);
    default:
      console.log("Unknown action type");
      return state;
  }
};

const loadCourse = (state, courses) => {
  let newState = [...courses];

  return newState;

  //console.log(curriculum.data.curriculums);
};
const addCourse = (state, course) => {
  const newState = [
    ...state,
    {
      owner: "software_engineering_dep",
      program: "2021curcurr",
      course_code: course.course_code,
      course_name: course.course_name,
      credit_hr: course.credit_hr,
      lecture: course.lecture,
      lab: course.lab,
      tutorial: course.tutorial,
      mentoring: course.mentoring,
      advisory: course.advisory,
      total_leh:
        course.tutorial + course.advisory + course.mentoring + course.lecture,
      disabled: course.disabled,
    },
  ];
  return newState;
};

const editCourse = (state, course) => {
  const newState = [...state];
  const index = newState.findIndex((c) => c.course_code === course.courseCode);
  newState[index] = {
    owner: "software_engineering_dep",
    program: "2021curcurr",
    course_code: course.course_code,
    course_name: course.course_name,
    credit_hr: course.credit_hr,
    lecture: course.lecture,
    lab: course.lab,
    tutorial: course.tutorial,
    mentoring: course.mentoring,
    advisory: course.advisory,
    total_leh:
      course.tutorial + course.advisory + course.mentoring + course.lecture,
    disabled: course.disabled,
  };
  return newState;
};

const disableCourse = (state, courseCode) => {
  const newState = [...state];
  const index = newState.findIndex((c) => c.course_code === courseCode);
  console.log(index);
  newState[index] = {
    ...newState[index],
    disabled: !newState[index].disabled,
  };
  return newState;
};
